import AuthLogin from '@polleverywhere/toolkit-auth/lib/multi_step_login'
import '@polleverywhere/toolkit-auth/lib/style/auth.scss'
import LogoTpl from '@polleverywhere/toolkit-lib/lib/templates/logo.hamlc'
import './style.scss'
import { unsafeSVG } from 'lit-html/directives/unsafe-svg'
import { outOfBandAuth } from '../../util/out_of_band_auth'
import '@polleverywhere/advisory-message'
import { template as oobPendingTpl } from '../../util/render_out_of_band_pending'
import store from '@polleverywhere/redux'
import { slice as appSlice } from '../../slices/app'
import { connect } from 'pwa-helpers/connect-mixin'
import { internalProperty, LitElement, html } from 'lit-element'
import ssoProviders from './sso_providers'
import startSession from '../../util/start_session'
import handleSaml from './handle_saml'
import { bemBlock } from '@polleverywhere/bem-helpers'
import { register } from '@polleverywhere/hmr-custom-element'

function footerTpl () {
  return html`
    <div class=${bem('alternates')}>
      <div class=${bem('alternate')}>
        <pe-button type=link label='Forgot password?' @click=${() => store.dispatch(appSlice.pageUpdated('reset_password'))}></pe-button>
      </div>
        ${signupTpl.call(this)}
    </div>
  `
}

function signupTpl () {
  if (this.signupEnabled) {
    return html`
      <div class=${bem('alternate')}>
        Need an account?
        <br />
        <pe-button type=link label='Create one now' @click=${() => store.dispatch(appSlice.pageUpdated('signup'))}></pe-button>
      </div>
    `
  }

  return ''
}

function oobAdvisoryLoginTpl () {
  return html`
    <advisory-message
    icon='link'
    subject='Log in to Poll Everywhere'
    message='To present live activities, please log in to your Poll Everywhere account in a separate window.'
    resolutionLabel='Launch log-in window'
    autofocus
    @resolve=${async () => {
      this.oobPending = true
      try {
        await outOfBandAuth({ signupEnabled: this.signupEnabled })
        window.location.reload()
      } catch (e) {
        console.error('OOB ERROR', e)
      }
    }}
  ></advisory-message>
  `
}

function buildForm () {
  this.form = new AuthLogin({
    sso: {
      providers: ssoProviders({
        role: this.role,
        finishedCallback: () => startSession()
      })
    },
    redux: true,
    upgradePresenter: this.upgradePresenter,
    includeAccount: true
  })

  this.form.on('click:provider', (detail = {}) => {
    handleSaml({
      role: this.role,
      url: detail.url
    })
  })

  this.form.render()
}

function standardLoginTpl () {
  if (!this.form) buildForm.call(this)

  return html`
    <div class=${bem('content')}>
      <div class=${bem('logo')}>
        ${unsafeSVG(LogoTpl())}
      </div>
      <h1 tabindex='-1'>Log in</h1>
      <div class=${bem('form')}>
        ${this.form.el}
      </div>
      ${footerTpl.call(this)}
    </div>
  `
}

export default class Login extends connect(store)(LitElement) {
  static tagName = 'pec-login-page'

  @internalProperty({ type: String })
  role

  @internalProperty({ type: Boolean })
  signupEnabled

  @internalProperty({ type: Boolean })
  outOfBand

  @internalProperty({ type: Boolean })
  oobPending = false

  @internalProperty({ type: Boolean })
  upgradePresenter

  /**
   * Legacy 'Auth' backbone view from toolkit for login or signup
   * @type {AuthLogin}
   */
  form

  stateChanged (state) {
    const { role, options } = state[appSlice.name]

    this.role = role
    this.signupEnabled = options.allowSignups
    this.outOfBand = role === 'agave'
    this.upgradePresenter = appSlice.selectAutomaticPresenterUpgrade(state)
  }

  createRenderRoot () { return this }

  connectedCallback () {
    super.connectedCallback()

    if (!this.outOfBand) {
      this.updateComplete.then(() => this.querySelector('h1').focus())
    }
  }

  render () {
    let tpl

    if (this.oobPending) {
      tpl = oobPendingTpl
    } else if (this.outOfBand) {
      tpl = oobAdvisoryLoginTpl.call(this)
    } else {
      tpl = standardLoginTpl.call(this)
    }

    return html`
    <layout-plain>
      <main slot='content'>
        ${tpl}
      </main>
    </layout-plain>
    `
  }

  disconnectedCallback () {
    this.form?.remove()
    this.form = undefined

    super.disconnectedCallback()
  }
}

const bem = bemBlock(Login.tagName)
register(module, Login.tagName, Login)
